function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-130722a5\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector?type=styles&index=0!./crm-pessoa-list.vue")
}
var normalizeComponent = require("!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector?type=script&index=0!./crm-pessoa-list.vue"
import __vue_script__ from "!!babel-loader!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector?type=script&index=0!./crm-pessoa-list.vue"
/* template */
import __vue_template__ from "!!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-130722a5\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector?type=template&index=0!./crm-pessoa-list.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/forms-crm/crm-pessoa-list.vue
// module id = 2063
// module chunks = 0